import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const helpScout = defineConnector({
  identifier: "helpScout",
  name: "Help Scout",
  tagLine: "Customer service platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.helpscout\\.net/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an OAuth application",
      items: [
        {
          kind: "markdown",
          content:
            "In Help Scout, go to **Your Profile > My Apps** and create a new app. Copy the App ID and App Secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "App ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "App secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api.helpscout.net/v2/oauth2/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.helpscout.net/v2/users/me",
  },
});
